export const hostIsAllcom = () => {
  const host = location.hostname.split('.')[0];
  const allcomUrls = ['localhost', 'allcom'];
  return allcomUrls.indexOf(host) !== -1;
};
